import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, LogOut, BookMarked } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import '../styles/UserMenu.css';

export default function UserMenu() {
  const { isAuthenticated, user, logout, loading } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  if (loading) return null;

  // When logged-out, defer to the LandingNav "Begin Journey" CTA per the
  // master mockup — no separate Sign in / Create account pill in the corner.
  if (!isAuthenticated) return null;

  const initial = (user?.name || user?.email || '?').trim().charAt(0).toUpperCase();

  return (
    <div className="user-menu" ref={ref}>
      <button
        type="button"
        className="user-menu-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid="usermenu-trigger"
      >
        <span className="user-menu-avatar">{initial}</span>
        <span className="user-menu-name">{user?.name?.split(' ')[0] || 'Account'}</span>
      </button>
      {open && (
        <div className="user-menu-dropdown" role="menu" data-testid="usermenu-dropdown">
          <p className="user-menu-greeting">
            <span className="user-menu-greeting-label">Welcome,</span>
            <span className="user-menu-greeting-name">{user?.name || user?.email}</span>
          </p>
          <button
            type="button"
            className="user-menu-item"
            onClick={() => { setOpen(false); navigate('/my-story'); }}
            data-testid="usermenu-my-story"
          >
            <BookMarked size={15} /> My Story
          </button>
          <button
            type="button"
            className="user-menu-item user-menu-item-danger"
            onClick={() => { logout(); setOpen(false); navigate('/'); }}
            data-testid="usermenu-logout"
          >
            <LogOut size={15} /> Log Out
          </button>
        </div>
      )}
    </div>
  );
}
